module Core {
    angular.module('core').filter('hiddenRestaurantFilter', [() => {
        return (input: IRestaurant[], mustBeHidden: boolean): IRestaurant[] => {
            return _.filter(input, (item) => item.hide === mustBeHidden);
        };
    }]);
}